import styled from '@emotion/styled';
import { TextField } from '@material-ui/core';
import React, { ReactNode } from 'react';

import { FormInputLabel } from './Typography';

const Input = styled('input')`
  width: 100%;
  box-sizing: border-box;
  font-size: 1.2rem;
  line-height: 1;
  color: inherit;
  background-color: rgb(255, 255, 255);
  border: none;
  border-bottom: 0.1rem solid rgb(198, 202, 215);
  border-image: initial;
  outline-width: 0;

  :focus {
    border-bottom: 0.1rem solid #1890ff;
  }

  :invalid {
    border-bottom: 0.1rem solid rgb(211, 47, 47);
  }
`;

const InputContainer = styled('div') <IFormInputProps>`
  padding-top: ${props => (props.labelPosition === 'top' ? '1.2rem' : '2rem')};
`;

export interface IFormInputProps {
  label: string;
  labelPosition?: 'top' | 'bottom';
  value?: string;
  disabled?: boolean;
  required?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormInput = (props: IFormInputProps) => {
  const { label, labelPosition } = props;
  return (
    <InputContainer {...props}>
      {labelPosition && labelPosition === 'top' && (
        <FormInputLabel bold>
          {' '}
          {label ? label.toUpperCase() : ''}{' '}
        </FormInputLabel>
      )}
      <Input {...props}></Input>
      {labelPosition !== 'top' && (
        <FormInputLabel bold>
          {' '}
          {label ? label.toUpperCase() : ''}{' '}
        </FormInputLabel>
      )}
    </InputContainer>
  );
};

export default FormInput;

interface IMaterialInputProps {
  marginTop?: boolean;
  marginRight?: boolean;
  noMarginBottom?: boolean;
  endAdornment?: ReactNode;
}

export const MaterialInput = styled(TextField) <IMaterialInputProps>`
  ${props => (props.marginTop ? 'margin-top: 1.2rem !important;' : '')};

  div {

    margin-bottom: ${props => (props.noMarginBottom ? '0px' : '1.2rem')};
  }

  label {
    font-size: 1.2rem;
    transform: translate(1rem, 1.1rem) scale(1);
  }

  input {
    font-size: 1.2rem;
    padding: 1rem;
    // to keep the inputs the same size across browsers
    min-height: 1.5rem;
  }

  textarea {
    font-size: 1.2rem;
  }

  margin-right: ${props => (props.marginRight ? '1.2rem !important' : '0')};
`;
